// extracted by mini-css-extract-plugin
module.exports = {"cabecalho":"ConfiguracaoSistema_cabecalho__163-Y"};